module.exports = __webpack_public_path__ + "img/deskshelf07.c73fd1da.jpg";